module.exports = __webpack_public_path__ + "ipetbooking-build/img/logo-default.67cc6a72.svg";